import React from 'react';
import { MessageSquareIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
const TelecomsHero = () => {
  return <section className="bg-gradient-to-br from-[#54d4cb] via-[#3ba69f] to-[#2d8a84] text-white py-20" data-id="element-436">
      <div className="container mx-auto px-4" data-id="element-437">
        <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-438">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-439">AI on SMS</h1>
          <p className="text-2xl md:text-3xl font-semibold mb-6 text-[#e3f7f6]" data-id="element-440">
            Unlocking Generative AI for Every Subscriber
          </p>
          <p className="text-lg md:text-xl leading-relaxed" data-id="element-441">
            Enable telecom operators to deliver the power of Generative AI to
            all subscribers — including those without data access. Using SMS,
            USSD, and voice, transform every phone into an intelligent assistant
            capable of answering questions, offering guidance, and engaging
            users in natural conversation — no internet required.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-442">
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center" data-id="element-443">
            <div className="inline-block p-3 bg-white/20 rounded-full mb-4" data-id="element-444">
              <TrendingUpIcon className="h-8 w-8 text-white" data-id="element-445" />
            </div>
            <h3 className="text-xl font-semibold mb-2" data-id="element-446">New Revenue Stream</h3>
            <p className="text-[#e3f7f6]" data-id="element-447">
              Subscription-based model drives recurring revenue from your
              existing subscriber base
            </p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center" data-id="element-448">
            <div className="inline-block p-3 bg-white/20 rounded-full mb-4" data-id="element-449">
              <UsersIcon className="h-8 w-8 text-white" data-id="element-450" />
            </div>
            <h3 className="text-xl font-semibold mb-2" data-id="element-451">Digital Inclusion</h3>
            <p className="text-[#e3f7f6]" data-id="element-452">
              Reach every subscriber, including prepaid and non-data users
            </p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center" data-id="element-453">
            <div className="inline-block p-3 bg-white/20 rounded-full mb-4" data-id="element-454">
              <MessageSquareIcon className="h-8 w-8 text-white" data-id="element-455" />
            </div>
            <h3 className="text-xl font-semibold mb-2" data-id="element-456">Built for Scale</h3>
            <p className="text-[#e3f7f6]" data-id="element-457">
              Leverage existing infrastructure for instant deployment to
              millions
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default TelecomsHero;